import React, {useState, useRef} from 'react';
import './GeneralInfoOrg.css';
import {ReactComponent as UploadIcon} from '../../images/upload.svg';
import {ReactComponent as EditIcon} from '../../images/edit-icon.svg';
import defaultImageOrg from '../../images/defaultImageOrg.webp';
import {ReactComponent as Loader} from '../../images/loader-icon.svg';
const GeneralInfoOrg = ({
  formDataGeneralInformation,
  handleChangeGeneralInformation,
  handleImageChange,
  isLoading,
  isLoadingImage,
  canEdit,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [aspectRatio, setAspectRatio] = useState('3/1');
  const dragCounter = useRef(0);

  const fileInputRef = useRef(null);

  const handleImageChangeWithAspectRatio = (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new Image();
      img.onload = () => {
        const newAspectRatio = img.width / img.height;
        setAspectRatio(newAspectRatio);
        handleImageChange(event);
      };
      img.src = URL.createObjectURL(file);
    }
  };

  const handleDragEnter = (event) => {
    if (!canEdit) return null;
    event.preventDefault();
    dragCounter.current += 1;
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    if (!canEdit) return null;

    event.preventDefault();
    dragCounter.current -= 1;
    if (dragCounter.current === 0) {
      setIsDragOver(false);
    }
  };

  const handleDragOver = (event) => {
    if (!canEdit) return null;

    event.preventDefault();
  };

  const handleDrop = (event) => {
    if (!canEdit) return null;

    event.preventDefault();
    dragCounter.current = 0;
    setIsDragOver(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      handleImageChangeWithAspectRatio({
        target: {name: 'image', files: [file]},
      });
    }
  };

  return (
    <div className='general-info-org'>
      <form className='general-info-org__form'>
        <div
          className={`general-info-org__image-container ${
            isDragOver ? 'drag-over' : ''
          }`}
          style={{'--aspect-ratio': aspectRatio}}
          onDragEnter={handleDragEnter}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            ref={fileInputRef}
            className='general-info-org__input'
            type='file'
            id='image'
            accept='image/*'
            onChange={handleImageChangeWithAspectRatio}
            disabled={!canEdit}
          />
          <label htmlFor='image' className='general-info-org__image-label'>
            <div
              style={{opacity: isLoadingImage ? '1' : ''}}
              className={`${canEdit ? 'general-info-org__image-overlay' : ''}`}
            >
              {isLoadingImage ? (
                <span className='general-info-org__loader-wrapper'>
                  <Loader />
                </span>
              ) : (
                <>
                  {canEdit && (
                    <span className='general-info-org__icon'>
                      <UploadIcon />
                    </span>
                  )}
                  {canEdit && (
                    <span className='general-info-org__image-text'>
                      {isDragOver
                        ? 'Отпустите файл здесь'
                        : 'Перетащите или загрузите изображение'}
                    </span>
                  )}
                </>
              )}
            </div>
            <img
              className='general-info-org__image'
              src={
                formDataGeneralInformation.image instanceof File
                  ? URL.createObjectURL(formDataGeneralInformation.image)
                  : formDataGeneralInformation.image?.trim()
                  ? formDataGeneralInformation.image
                  : defaultImageOrg
              }
              alt='Изображение организации'
            />
          </label>
        </div>

        <div
          className='general-info-org__description-container'
          onClick={() => (canEdit ? setIsEditing(true) : null)}
        >
          {isEditing ? (
            <div className='general-info-org__textarea-wrapper'>
              <textarea
                className='general-info-org__textarea'
                id='description'
                name='description'
                readOnly={!canEdit}
                value={formDataGeneralInformation.description}
                onChange={handleChangeGeneralInformation}
                placeholder='Введите описание организации'
                autoFocus
                maxLength={1000}
                onBlur={() => setIsEditing(false)}
              />
              {formDataGeneralInformation.description && (
                <div className='general-info-org__char-counter'>
                  {formDataGeneralInformation.description.length}/1000
                </div>
              )}
            </div>
          ) : (
            <div className='general-info-org__description'>
              {formDataGeneralInformation.description || (
                <span className='general-info-org__description-placeholder'>
                  Добавить описание
                </span>
              )}
              {canEdit && (
                <span className='general-info-org__edit-icon'>
                  <EditIcon />
                </span>
              )}
            </div>
          )}
        </div>

        {formDataGeneralInformation.errors?.description && (
          <div className='general-info-org__error'>
            {formDataGeneralInformation.errors.description}
          </div>
        )}
      </form>
    </div>
  );
};

export default GeneralInfoOrg;
